
  <div matTooltip="{{ 'Measuring & drawing tools' }}" matTooltipPosition="right">
  <button
      *ngIf="(flagService.getFlags$() | async)?.[FeatureFlags.MEASURES]"
      matIconButton
    [disabled]="!measurementToolAllowed"
    id="measure-drawing-button"
    class="mat-icon-toggle-button"
    [class.selected]="activeToolPanel"
    type="button"
    (click)="showToolsPanel()">
    <mat-icon svgIcon="measure"></mat-icon>
  </button>
</div>
